import React from 'react';

import type { ContainerComponent } from '../../common/types/Common';

const UpdateBadgeCount: ContainerComponent = ({ children }) => {
    return <>{children}</>;
};

export default UpdateBadgeCount;
